import {Button, Grid, IconButton, MenuItem, Paper, Stack, TableCell, TextField, useTheme} from "@mui/material";
import {useTranslation} from 'react-i18next';
import AgGridCustomTable from '../../../../util/component/AgGridCustomTable';
import SectionHeader from '../../../../util/component/SectionHeader';
import {Cancel, CheckCircle, ReplayRounded, SearchRounded, TextSnippet} from '@mui/icons-material';
import {ColDef, GridOptions} from 'ag-grid-community';
//import { AgGridReact } from 'ag-grid-react';
import {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {Category} from '../../interfaces/Category';
import {useVoucherActions} from '../../service/useMobilityVoucherAction';
import {Controller, useForm} from 'react-hook-form';
import {Order} from '../../interfaces/Order';
import dayjs from "dayjs";
import {useRecoilState} from "recoil";
import {STEPPER_STATE} from "../../service/MobilityVoucherRecoil";
import {useHasScope} from "../../../../config/globalConfig";

const toFloatCurrency= (val : string )=>{
  return parseFloat(val)/100 + " €";
}

const MobilityVoucherDashboardPage = () => {

  const { t } = useTranslation(['mobilityvoucher']);
  const navigate = useNavigate();
  const theme = useTheme();
  //const gridRef = useRef<AgGridReact>(null);
  const [categories, setCategories] = useState<Category[]>([{ categoryName: "" }]);
  const { getCategories, getLastOrders } = useVoucherActions();
  const [rowComplete, setRowComplete] = useState<Order[]>([]);
  const [rowNotComplete, setRowNotComplete] = useState<Order[]>([]);
  const [activeStep, setActiveStep] = useRecoilState(STEPPER_STATE);
  const hasScope = useHasScope;
  const defaultValues = {
    category: '',
    subscription: ''
  };
  const {
    control,
    handleSubmit,
    formState: { isValid },
    reset,
  } = useForm({ mode: "onChange", defaultValues });

  const  detailsOrder = async (id: any) => {
    window.open('/mobilityvoucher/details-order/' + id); 
  }

  const columnsOrderComplete: ColDef[] = [
    {
      field: "orderDate",
      headerName: t('ordertable.data'),
      unSortIcon: false,
      valueFormatter: params => params.value ? dayjs(params.value).format("lll") : ''
    },
    {
      field: "orderNumber",
      headerName: t('ordertable.order'),
      unSortIcon: false,
    },
    {
      field: "subscription",
      headerName: t('ordertable.subscription'),
      unSortIcon: false,
      cellRenderer: (params: any) => {
          return (<TableCell align="left">
          {params.data.subscription.productCode} - {params.data.subscription.name}
        </TableCell>);
      }
    },
    {
      field: "customer",
      headerName: t('ordertable.customer'),
      unSortIcon: false,
      cellRenderer: (params: any) => {
        if (params.data.customer.companyName) {
            return (
                <TableCell align="left">
                {params.data.customer.companyName}
                </TableCell>
            );
        } else {
            return (
                <TableCell align="left">
                {params.data.customer.firstName}  {params.data.customer.lastName}
                </TableCell>
            ); 
        }
      }
    },
    {
      field: "amount",
      headerName: t('ordertable.amount'),
      unSortIcon: false,
      valueGetter: params => {
        return toFloatCurrency(params.data.amount);
      }
    },
    {
      field: "_actions",
      headerName: t('ordertable.action'),
      pinned: 'right',
      lockPosition: 'right',
      lockPinned: false,
      maxWidth: 160,
      sortable: false,
      cellRenderer: (params: any) => {
        return (
          <>{hasScope('SCOPE_MV_ORDERS_DETAILS_VIEW')?
            <Stack direction={"row"} justifyContent={"center"}>
                <IconButton onClick={() => detailsOrder(params.data.id)} color="accent">
                  <TextSnippet/>
                </IconButton>
            </Stack>:<></>
          }
        </>
        );
      }
    },
    {
      field: "voucherCode",
      headerName: t('ordertable.voucher'),
      unSortIcon: false,
      hide: false
    }, 
    {
        field: "voucherState",
        headerName: t('ordertable.voucherState'),
        width: 100,
        sortable: false,
        cellRenderer: (params: any) => {
          return (
            <>
            { params.data.voucherCode ?
                <>
                    { params.data.voucherState === "AVAILABLE" ?
                        <CheckCircle sx={{mt: theme.spacing(1)}}/>
                        :
                        <Cancel sx={{mt: theme.spacing(1)}}/>
                    }
                </>
             : 
                <></>
            }
            </>
          );
        }
    }
  ];

  const columnsOrderNotComplete: ColDef[] = [
    {
      field: "orderDate",
      headerName: t('ordertable.data'),
      unSortIcon: false,
      valueFormatter: params => params.value ? dayjs(params.value).format("lll") : ''
    },
    {
      field: "orderNumber",
      headerName: t('ordertable.order'),
      unSortIcon: false,
    },
    {
      field: "subscription",
      headerName: t('ordertable.subscription'),
      unSortIcon: false,
      cellRenderer: (params: any) => {
          return (<TableCell align="left">
          {params.data.subscription.productCode} - {params.data.subscription.name}
        </TableCell>);
      }
    },
    {
      field: "customer",
      headerName: t('ordertable.customer'),
      unSortIcon: false,
      cellRenderer: (params: any) => {
        if (params.data.customer.companyName) {
            return (
                <TableCell align="left">
                {params.data.customer.companyName}
                </TableCell>
            );
        } else {
            return (
                <TableCell align="left">
                {params.data.customer.firstName}  {params.data.customer.lastName}
                </TableCell>
            ); 
        }
      }
    },
    {
      field: "amount",
      headerName: t('ordertable.amount'),
      unSortIcon: false,
      valueGetter: params => {
        return toFloatCurrency(params.data.amount);
      }
    },
    {
      field: "_actions",
      headerName: t('ordertable.action'),
      pinned: 'right',
      lockPosition: 'right',
      lockPinned: false,
      maxWidth: 160,
      sortable: false,
      cellRenderer: (params: any) => {
        return (
        <>{hasScope('SCOPE_MV_ORDERS_DETAILS_VIEW')?
          <Stack direction={"row"} justifyContent={"center"}>
              <IconButton onClick={() => detailsOrder(params.data.id)} color="accent">
              <TextSnippet/>
              </IconButton>
          </Stack>:<></>
          }
        </>
        );
      }
    }
  ];

  const gridOptionsOrderNotComplete: GridOptions = {
    suppressRowClickSelection: true,
    domLayout: 'autoHeight',
    pagination: false,
    defaultColDef: {
      sortable: false,
      resizable: true,
      wrapHeaderText: true
    },
    columnDefs: columnsOrderNotComplete
  };

  const gridOptionsOrderComplete: GridOptions = {
    suppressRowClickSelection: true,
    domLayout: 'autoHeight',
    pagination: false,
    defaultColDef: {
      sortable: false,
      resizable: true,
      wrapHeaderText: true
    },
    columnDefs: columnsOrderComplete
  };

  const toolbarOrder = {
    renderInfo: ({ ref }: any) => (
      <h2>{t('dashboard.order.nocomplete')}</h2>
    )
  };

  const toolbarCompleteOrder = {
    renderInfo: ({ ref }: any) => (
      <h2>{t('dashboard.order.last')}</h2>
    )
  };

  const onGridReady = () => {
    // gridRef.current?.columnApi.setColumnVisible('voucherCode', true);
  };

  const addNewOrder = () => {
    navigate('/mobilityvoucher/new-order');
    setActiveStep((prevActiveStep: number) => 0);
  };


  useEffect(() => {
    getCategories().then((res) => setCategories(res));
    getLastOrders('', '').then((res: Order[]) => {
      setRowComplete(res.filter((order) => order.orderState === 'COMPLETED'));
      setRowNotComplete(res.filter((order) => order.orderState === 'NOT_COMPLETED'));
    });
  }, []);

  const searchOrder = (category: string, subscription?: string) => {
    getLastOrders(category, subscription).then((res: Order[]) => {
      setRowComplete(res.filter((order) => order.orderState === 'COMPLETED'));
      setRowNotComplete(res.filter((order) => order.orderState === 'NOT_COMPLETED'));
    });
  };

  const onFormSubmit = (data: any) => {
    searchOrder(data.category, data.subscription);
  };

  const onErrors = (errors: any) => console.error(errors);

  const resetForm = () => {
    reset(defaultValues);
    onFormSubmit({});
  }
 
  return (
    <>
      <SectionHeader title={t('mobilityvoucher:dashboard.createHeader.title')}
        subtitle={t('mobilityvoucher:dashboard.createHeader.subTitle')} />

      <Grid container display={'flex'} alignItems={'center'} justifyContent={'center'}>

        <Grid item xs={12} sm={12} xl={12}>

          <Paper elevation={1} sx={{ padding: "16px", margin: "18px" }}>
            <form onSubmit={handleSubmit(onFormSubmit, onErrors)} noValidate>
              <Grid container alignItems="center" spacing={2} >

                <Grid item xs={4}>
                  <Controller
                    name='category'
                    control={control}
                    render={({ field: { ref, ...field }, fieldState }) => (
                      <TextField
                        select
                        label={t('mobilityvoucher:filterBox.category')}
                        placeholder={t('mobilityvoucher:filterBox.category')}
                        fullWidth
                        value={field.value}
                        defaultValue={''}
                        onChange={field.onChange}
                        error={!!fieldState.error}
                        helperText={fieldState.error?.message}
                      >
                        <MenuItem key={""} value={""}/>
                        {categories && categories?.map((category) => (
                          <MenuItem key={category.categoryName} value={category.categoryName}>{category.categoryName}</MenuItem>
                        ))}

                      </TextField>
                    )}
                  />
                </Grid>

                <Grid item xs={4}>
                  <Controller
                    name='subscription'
                    control={control}
                    render={({ field: { ref, ...field }, fieldState }) => (
                      <TextField
                        fullWidth
                        inputProps={{ maxLength: 120 }}
                        placeholder={t('mobilityvoucher:filterBox.subscription')}
                        label={t('mobilityvoucher:filterBox.subscription')}
                        value={field.value}
                        defaultValue={''}
                        onChange={field.onChange}
                        error={!!fieldState.error}
                        helperText={fieldState.error?.message}
                      />
                    )}
                  />

                </Grid>

                <Grid  item xs={4}>
                    <Stack direction="row" alignItems="center" justifyContent="end" columnGap={2}>
                        <Button variant="text" startIcon={<ReplayRounded/>} onClick={resetForm}>
                            {t("searchTooltip.clearFilters")}
                        </Button>  
                        <Button type="submit" size="icon" color="accent">
                            <SearchRounded/>
                        </Button>
                    </Stack> 
                </Grid>
              </Grid>
            </form>
          </Paper>
        </Grid>

      </Grid>

      <Paper elevation={3} sx={{ padding: "16px", margin: "18px" }}>
        <AgGridCustomTable rowData={rowComplete} toolbar={toolbarCompleteOrder} gridOptions={{ ...gridOptionsOrderComplete }} pagination={false}></AgGridCustomTable>
      </Paper>

      <Paper elevation={3} sx={{ padding: "16px", margin: "18px" }}>
        <AgGridCustomTable rowData={rowNotComplete} toolbar={toolbarOrder} gridOptions={{ ...gridOptionsOrderNotComplete }} pagination={false}></AgGridCustomTable>
      </Paper>
    </>
  );
};

export default MobilityVoucherDashboardPage;